module.exports = __webpack_public_path__ + "static/media/icon-circle.31bfc775.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-circle.svg
// module id = 315
// module chunks = 0